export class InvalidTokenError extends Error {
    constructor(error: Error) {
        super(error.message)
        this.cause = error.cause
        this.name = "InvalidTokenError"
        Object.setPrototypeOf(this, InvalidTokenError.prototype)
    }
}
